export const initStorage = () => {
  let keys = [`bc-prices`,`bc-stats`,`bc-wallet`,`last_height`,`my_maker_map`,`my_orders`,`nrg-history`,`pendingTransactions`,`pendingTransfers`,`settings`,`spendable-outpoints`,`trade-addresses`];
  let update = false;
  for(let key of keys) {
    let val = window.localStorage.getItem(key);
    if(val){
      try {
        if(JSON.parse(val)) {
          window.setStorage(key,val)
          update = true;
        }
      }
      catch(err){
        // console.log({err,key})
      }
    }
  }
  if(update) window.location.reload()
}
